import { render } from "./DemandeExam.vue?vue&type=template&id=473f4b2d&scoped=true"
import script from "./DemandeExam.vue?vue&type=script&lang=js"
export * from "./DemandeExam.vue?vue&type=script&lang=js"

import "./DemandeExam.vue?vue&type=style&index=0&id=473f4b2d&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-473f4b2d"]])

export default __exports__